import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import { Dialog } from '@ori-ui/components';
import { styled } from '@ori-ui/mui';
export var Root = styled(Dialog, {
  shouldForwardProp: function shouldForwardProp(propName) {
    return propName !== 'zIndex';
  }
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  z-index: ", ";\n\n  button {\n    z-index: ", ";\n  }\n\n  & .MuiOriDialogBase-closeButton {\n    z-index: 10;\n  }\n\n  & .MuiPaper-root {\n    ", " {\n      height: 450px;\n      overflow: visible;\n      width: 766px;\n    }\n\n    ", " {\n      width: 855px;\n    }\n  }\n"])), function (_ref) {
  var zIndex = _ref.zIndex;
  return zIndex;
}, function (_ref2) {
  var zIndex = _ref2.zIndex;
  return typeof zIndex === 'number' ? zIndex + 1 : undefined;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.up('md');
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.breakpoints.up('lg');
});